import options from './rule.component';

export default {
    selector: 'dtRule',
    options
};



// WEBPACK FOOTER //
// ./app/common/rule/index.js